import { render, staticRenderFns } from "./viewCard.vue?vue&type=template&id=fa3283b4&scoped=true&"
import script from "./viewCard.vue?vue&type=script&lang=js&"
export * from "./viewCard.vue?vue&type=script&lang=js&"
import style0 from "./viewCard.vue?vue&type=style&index=0&id=fa3283b4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa3283b4",
  null
  
)

export default component.exports